import React, { useState } from "react";
import { ModalBuilder, Form } from "@redriver/cinnamon";
import { Button, Grid } from "semantic-ui-react";
import { saveMeterCodeData, getMeterCodeData } from "./actions";
import MeterCodeGroup from "./MeterCodeGroup";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";

function getSizeOfPreviousList(parentFields, arrayIndex) {
  let relevant = parentFields.groups.slice(0, arrayIndex);
  let position = 0;
  relevant.forEach((x) => (position += x.meterCodeItem.length));
  position += arrayIndex;
  return position;
}

const TriggerButton = ({ onClick }) => {
  const { t } = useTranslation("productSchedule");

  return (
    <Button primary className="ps-save-button">
      <div onClick={onClick}>{t("Enter_Meter_Codes")}</div>
    </Button>
  );
};

const MeterCodeModal = ({
  sheetId,
  onSubmitted,
  onSubmit,
  saveRequired,
  isProductScheduleValid,
  disabled,
}) => {
  const { t } = useTranslation("productSchedule");
  const [psSaving, setPsSaving] = useState(false);

  return (
    <ModalBuilder
      withForm
      loadAction={getMeterCodeData}
      loadParams={sheetId}
      submitAction={saveMeterCodeData}
      submitParams={sheetId}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) =>
        saveRequired ? (
          <ModalBuilder
            renderModal={(modalProps, events) =>
              isProductScheduleValid ? (
                <TranslatedModal.Confirmation
                  {...modalProps}
                  submitting={psSaving}
                  onSubmit={async () => {
                    setPsSaving(true);
                    const { success } = await onSubmit();
                    setPsSaving(false);
                    if (!success) {
                      events.onCancel();
                      return;
                    }
                    showModal();
                    modalProps.onSubmit();
                  }}
                >
                  {t("meter_codes_save_warning")}
                </TranslatedModal.Confirmation>
              ) : (
                <TranslatedModal.Information {...modalProps}>
                  {t("complete_warning")}
                </TranslatedModal.Information>
              )
            }
            renderTrigger={(showInnerModal) => (
              <TriggerButton onClick={showInnerModal} />
            )}
          />
        ) : (
          <TriggerButton onClick={showModal} />
        )
      }
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          className="meter-reading-modal"
          submitLabel={t("Save")}
          submitDisabled={disabled}
          header={t("Meter_Codes")}
        >
          <div className="meter-reading-list-container">
            <div className="meter-reading-list">
              <Form {...formProps} readOnly={disabled || formProps.readOnly}>
                <Grid className="meter-item-group">
                  <Grid.Row className="meter-reading-item header">
                    <Grid.Column width={1}>{t("Item")}</Grid.Column>
                    <Grid.Column width={4}>{t("Item_Description")}</Grid.Column>
                    <Grid.Column width={3}>
                      {t("Manufacturer_Model")}
                    </Grid.Column>
                    <Grid.Column width={3}>
                      {t("Identifier_Number")}
                    </Grid.Column>
                    <Grid.Column width={1}>{t("Tier")}</Grid.Column>
                    <Grid.Column width={3}>{t("Meter_Code")}</Grid.Column>
                  </Grid.Row>
                </Grid>
                <div className="meter-reading-groups">
                  <Form.Array arrayKey="id" field="groups">
                    {({ fields, arrayIndex, parentFields, formFields }) => (
                      <MeterCodeGroup
                        startPosition={getSizeOfPreviousList(
                          parentFields,
                          arrayIndex,
                          fields
                        )}
                        length={fields.meterCodeItem.length}
                        isFirstGroup={arrayIndex === 0}
                        isLastGroup={
                          arrayIndex === formFields.groups.length - 1
                        }
                        disabled={disabled}
                      ></MeterCodeGroup>
                    )}
                  </Form.Array>
                </div>
              </Form>
            </div>
          </div>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default MeterCodeModal;
